import React, {Component} from 'react';
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import Skeleton from "../../components/Skeleton/Skeleton";
import ContentPanel from "../../components/ContentPanel/ContentPanel";
import withRouter from "react-router/es/withRouter";
import connect from "react-redux/es/connect/connect";
import {REQUEST_SERVICE_LEVEL_PRODUCTS_DATA} from "../../actions/serviceLevelProductsActions";
import {REQUEST_SERVICE_LEVEL_SPECIALTIES_DATA} from "../../actions/serviceLevelSpecialtiesActions";
import CardsList from '../../components/CardsList/CardsList';
import {Helmet} from "react-helmet";
import store from '../../store/index';

const mapStateToProps = state => {
    return {
        serviceLevelsContentData: state.serviceLevelsContentData
    }
};

const mapDispatchToProps = dispatch => ({
    getServiceLevelProductsData: () => dispatch({type: REQUEST_SERVICE_LEVEL_PRODUCTS_DATA}),
    getServiceLevelsSpecialtiesData: () => dispatch({type: REQUEST_SERVICE_LEVEL_SPECIALTIES_DATA})
});


class Products extends Component {

    componentDidMount() {
        if (!this.props.serviceLevelsContentData.products) {
            this.props.getServiceLevelProductsData();
        }
        if (!this.props.serviceLevelsContentData.specialties) {
            this.props.getServiceLevelsSpecialtiesData();
        }
    }

    render() {
        return (
                <div className="wrapper">
                    <Helmet>
                        {
                            store.getState().sitemapData.sitemap ? store.getState().sitemapData.sitemap.map((row) => {
                                return row.rowTitle === "Ship" ? row.sections.map((section) => {
                                    return section.title === "Products" ? <meta name="description" content={section.content['seo-description']}/> : null
                                }) : null
                            }) : null
                        }
                    </Helmet>
                    <Breadcrumbs pageTitle="Products"/>
                    <ContentPanel
                            skeleton={<Skeleton type="MAIN_PANEL"/>}
                            errorTemplate={<Skeleton type="MAIN_PANEL_ERROR"/>}
                            templateUrl="./content/ship/page-components/text-block/service-levels-heading.html"
                    />
                    <div className="box-wrapper">
                        {
                            this.props.serviceLevelsContentData.products ?
                                    <CardsList
                                            wrapperClass="cards-list__cards-block-container_small"
                                            layoutData={Object.keys(this.props.serviceLevelsContentData.products).length ? this.props.serviceLevelsContentData.products : null}
                                            hasViewSwitcher={false}
                                            hasCardsView={true}
                                            showDatesOfIndividualContent={true}
                                    />
                                    : <Skeleton type="CONTENT_PANEL"/>
                        }A
                    </div>
                    <h2 className="h1">Product Comparison</h2>
                    <div className="service-comparison">
                        <div className="service-comparison__columns-container">
                            <div className="service-comparison__column">
                                <div className="service-comparison__main-title service-comparison__main-title--primary-dark-blue">NFG
                                </div>
                                <div className="service-comparison__absolute-row-container">
                                    <div className="service-comparison__absolute-row">
                                        <img src="./assets/icons/checkmark.svg" alt="" className="service-comparison__checkmark"/>
                                    </div>
                                    <div className="service-comparison__absolute-row"></div>
                                    <div className="service-comparison__absolute-row"></div>
                                    <div className="service-comparison__absolute-row">
                                        <p className="service-comparison__row-title mtn">100%</p>
                                    </div>
                                    <div className="service-comparison__absolute-row">
                                        <img src="./assets/icons/checkmark.svg" alt="" className="service-comparison__checkmark"/>
                                    </div>
                                    <div className="service-comparison__absolute-row">
                                        <p className="service-comparison__row-title mtn">45 Min<sup>3</sup></p>
                                    </div>
                                    <div className="service-comparison__absolute-row">
                                        <p className="service-comparison__row-title mtn">45 Min<sup>3</sup></p>
                                    </div>
                                    <div className="service-comparison__absolute-row">
                                        <p className="service-comparison__row-title mtn">45 Min<sup>3</sup></p>
                                    </div>
                                    <div className="service-comparison__absolute-row">
                                        <img src="./assets/icons/checkmark.svg" alt="" className="service-comparison__checkmark"/>
                                    </div>
                                </div>
                            </div>
                            <div className="service-comparison__column">
                                <div className="service-comparison__main-title service-comparison__main-title--secondary-light-blue">Standard
                                </div>
                                <div className="service-comparison__absolute-row-container">
                                    <div className="service-comparison__absolute-row"></div>
                                    <div className="service-comparison__absolute-row">
                                    </div>
                                    <div className="service-comparison__absolute-row"><img src="./assets/icons/checkmark.svg" alt="" className="service-comparison__checkmark"/>
                                    </div>
                                    <div className="service-comparison__absolute-row">
                                        <p className="service-comparison__row-title mtn"></p>
                                    </div>
                                    <div className="service-comparison__absolute-row">
                                        <img src="./assets/icons/checkmark.svg" alt="" className="service-comparison__checkmark"/>
                                    </div>
                                    <div className="service-comparison__absolute-row">
                                        <p className="service-comparison__row-title mtn">90 Min</p>
                                    </div>
                                    <div className="service-comparison__absolute-row">
                                        <p className="service-comparison__row-title mtn">90 Min</p>
                                    </div>
                                    <div className="service-comparison__absolute-row">
                                        <p className="service-comparison__row-title mtn">90 Min</p>
                                    </div>
                                    <div className="service-comparison__absolute-row">
                                        <img src="./assets/icons/checkmark.svg" alt="" className="service-comparison__checkmark"/>
                                    </div>
                                </div>
                            </div>
                            <div className="service-comparison__column">
                                <div className="service-comparison__main-title service-comparison__main-title--neutral-grey">Fresh Fast</div>
                                <div className="service-comparison__absolute-row-container">
                                    <div className="service-comparison__absolute-row"></div>
                                    <div className="service-comparison__absolute-row"><img src="./assets/icons/checkmark.svg" alt="" className="service-comparison__checkmark"/>
                                    </div>
                                    <div className="service-comparison__absolute-row">

                                    </div>
                                    <div className="service-comparison__absolute-row">
                                        <p className="service-comparison__row-title mtn">50%</p>
                                    </div>
                                    <div className="service-comparison__absolute-row">
                                        <img src="./assets/icons/checkmark.svg" alt="" className="service-comparison__checkmark"/>
                                    </div>
                                    <div className="service-comparison__absolute-row">
                                        <p className="service-comparison__row-title mtn">45 Min<sup>3</sup></p>
                                    </div>
                                    <div className="service-comparison__absolute-row">
                                        <p className="service-comparison__row-title mtn">45 Min<sup>3</sup></p>
                                    </div>
                                    <div className="service-comparison__absolute-row">
                                        <p className="service-comparison__row-title mtn">45 Min<sup>3</sup></p>
                                    </div>
                                    <div className="service-comparison__absolute-row">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="service-comparison__row">
                            <div className="service-comparison__row-content">
                                <div className="service-comparison__row-title">Flight Specific Guarantee</div>
                            </div>
                        </div>
                        <div className="service-comparison__row">
                            <div className="service-comparison__row-content">
                                <div className="service-comparison__row-title">24 Hour Guarantee<sup>1</sup></div>
                            </div>
                        </div>
                        <div className="service-comparison__row">
                            <div className="service-comparison__row-content">
                                <div className="service-comparison__row-title">Space Available</div>
                            </div>
                        </div>
                        <div className="service-comparison__row">
                            <div className="service-comparison__row-content">
                                <div className="service-comparison__row-title">Refund Guarantee<sup>2</sup></div>
                            </div>
                        </div>
                        <div className="service-comparison__row">
                            <div className="service-comparison__row-content">
                                <div className="service-comparison__row-title">Online Shipment Tracking</div>
                            </div>
                        </div>
                        <div className="service-comparison__row">
                            <div className="service-comparison__row-content">
                                <div className="service-comparison__row-title">Minimum Connection Times</div>
                            </div>
                        </div>
                        <div className="service-comparison__row">
                            <div className="service-comparison__row-content">
                                <div className="service-comparison__row-title">Cutoff Times</div>
                            </div>
                        </div>
                        <div className="service-comparison__row">
                            <div className="service-comparison__row-content">
                                <div className="service-comparison__row-title">Recovery Times</div>
                            </div>
                        </div>
                        <div className="service-comparison__row">
                            <div className="service-comparison__row-content">
                                <div className="service-comparison__row-title">International and Interline Available</div>
                            </div>
                        </div>
                    </div>

                    <p className="mtl"></p>
                    <p className="mtl"><sup>1</sup>Guaranteed to reach final destination within 24 hours once processing is complete from time
                        of tender.</p>
                    <p className="mts"><sup>2</sup>This can vary depending on the shipment, destination, and route. For a complete list of
                        fees
                        and refunds <a href="./content/home/assets/pdfs/Approved_CargoContractofCarriage.pdf" target="_blank">view here.</a></p>

                    <p className="mts"><sup>3</sup>Dependent upon station if current cutoff/recovery/connection times are greater than 45 minutes,
                        they stay at the current value for NFG and Fresh Fast.</p>

                    <div className="mvl pbm">
                        {
                            this.props.serviceLevelsContentData.specialties ?
                                    <CardsList
                                            layoutData={Object.keys(this.props.serviceLevelsContentData.specialties).length ? this.props.serviceLevelsContentData.specialties : null}
                                            hasViewSwitcher={false}
                                            hasCardsView={true}
                                            showDatesOfIndividualContent={true}
                                    />
                                    : <Skeleton type="CONTENT_PANEL"/>
                        }
                    </div>
                </div>
        )
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Products));



// WEBPACK FOOTER //
// ./src/pages/ship/Products.js